import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function Loader() {
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = performance.now();
    const duration = 1800;
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      setProgress(Math.floor(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(() => setVisible(false), 350);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="site-loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.9, ease: [0.19, 1, 0.22, 1] } }}
          className="fixed inset-0 z-[60] bg-[#0F0F0F] flex items-end pointer-events-none"
        >
          <motion.div
            initial={{ y: 0 }}
            exit={{ y: "-102%", transition: { duration: 1.1, ease: [0.87, 0, 0.13, 1], delay: 0.05 } }}
            className="absolute inset-0 bg-[#0F0F0F]"
          />
          <div className="relative w-full px-6 md:px-10 pb-8 md:pb-10 flex items-end justify-between text-white">
            <div>
              <div className="overline mb-3 !text-white/50">Mezcal · Oaxaca</div>
              <div className="font-serif text-white text-[44px] md:text-[68px] leading-none tracking-[0.02em]">
                SACRVM
              </div>
            </div>
            <div className="text-right">
              <div className="font-serif text-white text-[52px] md:text-[80px] leading-none tabular-nums">
                {String(progress).padStart(3, "0")}
              </div>
              <div className="overline !text-white/40 mt-2">Loading</div>
            </div>
          </div>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: progress / 100 }}
            transition={{ ease: "linear" }}
            style={{ transformOrigin: "left" }}
            className="absolute bottom-0 left-0 h-px w-full bg-[color:var(--sacrvm-gold)]"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
